<script lang="ts" setup>
const emit = defineEmits<{
  (
    e: 'submit',
    value: {
      text: string
      href: string
    }
  ): void
}>()

const show = ref(false)
const value = ref({
  text: '',
  href: ''
})

function reset() {
  value.value = {
    text: '',
    href: ''
  }
}

function onClick() {
  emit('submit', value.value)
  show.value = false
  reset()
}

function onCancel() {
  show.value = false
  reset()
}
</script>

<template>
  <div class="m-sticker">
    <div class="m-sticker__button" @click="show = !show">
      <slot />
    </div>
    <m-modal v-model="show" title="添加链接">
      <div class="rich-text-insert-link-form">
        <n-input
          v-model:value="value.text"
          class="form-item"
          placeholder="请输入链接文本"
        />
        <n-input
          v-model:value="value.href"
          class="form-item"
          placeholder="请输入链接地址"
        />
        <div class="button-wrap">
          <n-button class="button" @click="onCancel"> 取消 </n-button>
          <n-button type="primary" class="button" @click="onClick">
            确定
          </n-button>
        </div>
      </div>
    </m-modal>
  </div>
</template>

<style lang="scss" scoped>
.rich-text-insert-link-form {
  .form-item {
    margin-bottom: 12px;
  }

  .button-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    user-select: none;
  }
  .button {
    margin: 0 8px;
  }
}
.m-sticker {
  &__button {
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  &__list {
    position: absolute;
    top: 49px;
    left: 0;
    width: 418px;
    max-height: 288px;
    z-index: 100;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    background: #fff;
    padding: 12px;
    user-select: none;
    overflow-y: auto;
  }
  &__item {
    display: inline-block;
    width: 65px;
    height: 65px;
    margin: 5px;
    vertical-align: bottom;
    background-size: cover;
    background-position: center;
    cursor: pointer;
  }
}
</style>
